$(document).ready( function() {
    //We always get the UTM values in case its coming in on a different page than the form
    setupUtmCookie ('source','utm_source');
    setupUtmCookie ('medium','utm_medium');
    setupUtmCookie ('campaign','utm_campaign');
    if(!!document.getElementById('contact-us-form-block')){
        //Set the form source field
        if(formSourceValue){
            $(document).on('nfFormReady', function(e, layoutView) {
                $('input[name="form_source"]').val(formSourceValue).trigger('change');
            });
        }
        $(document).on('nfFormReady', function(e, layoutView) {
            setupNinjaFormsUtm();
        });
    }
});

jQuery(document).ready( function() {
    jQuery(document).on('nfFormSubmitResponse', function(event, response, id) {
        var dataLayerObject = {
            event: 'ninjaFormSubmission',
            ninjaFormResponseID: response,
        }
        window.parent.postMessage(dataLayerObject, '*');
    });
});

function getCookieValue(name){
    let re = new RegExp(name + "=([^;]+)");
    let value = re.exec(document.cookie);
    return (value != null) ? unescape(value[1]) : null;
}

//Setup the UTM param queries into cookies if GTM isn't loaded
function setupUtmCookie (cookie, parameterKey) {
    const urlParams = new URLSearchParams(window.location.search);
    const parameterValue = urlParams.get(parameterKey);
    if(!parameterValue) return;
    var expirationTime = 2592000 * 1000; // One month in milliseconds
    var date = new Date();
    var dateTimeNow = date.getTime();
    date.setTime(dateTimeNow + expirationTime); // Sets expiration time (Time now + one month)
    var date = date.toUTCString(); // Converts milliseconds to UTC time string
    document.cookie = cookie+"="+parameterValue+"; SameSite=None; Secure; expires="+date+"; path=/; domain=." + location.hostname.replace(/^www\./i, ""); // Sets cookie for all subdomains;
}

//Setup the UTM_Source and UTM_Medium fields on the Ninja Forms
window.setupNinjaFormsUtm = function () {
    if(!!document.getElementById('contact-us-form-block')){
        var utmSource = getCookieValue('source') ? getCookieValue('source') : 'not_set';
        var utmMedium = getCookieValue('medium') ? getCookieValue('medium') : 'not_set';
        var utmCampaign = getCookieValue('campaign') ? getCookieValue('campaign') : 'not_set';
        $('input[name="utm_source"]').val(utmSource).trigger('change');
        $('input[name="utm_medium"]').val(utmMedium).trigger('change');
        $('input[name="utm_campaign"]').val(utmCampaign).trigger('change');
    }
}